<!--
* @Component:
* @Maintainer: J.K. Yang
* @Description:
-->
<script setup lang="ts">
import configs from "@/configs";
import MainMenu from "@/components/navigation/MainMenu.vue";
import { useCustomizeThemeStore } from "@/stores/customizeTheme";
import { useAuthStore } from "~/src/stores/auth.store";

const customizeTheme = useCustomizeThemeStore();
const navigation = ref();
const auth = useAuthStore();

onMounted(() => {
  scrollToBottom();
});

watch(
  () => auth.isLoggedIn,
  () => {
    if (auth.isLoggedIn) {
      navigation.value = configs.navigation();
      navigation.value.menu.forEach(menuItems => {
        const items = menuItems.items.filter((x) => {
          return x.role?.includes(auth.role ?? '');
        });
        menuItems.items = items;
      });

      // resources.fetchAppConfig().then((res) => {
      //   appConfig.value = resources.appConfig;
      // })

    }
  }, { immediate: true }
)

const scrollToBottom = () => {
  const contentArea = document.querySelector(".v-navigation-drawer__content");
  const activeItem = document.querySelector(
    ".v-list-item--active"
  ) as HTMLElement;

  setTimeout(() => {
    contentArea?.scrollTo({
      top: activeItem?.offsetTop,
    });
  }, 100);
};
</script>

<template>
  <v-navigation-drawer border="none" elevation="1" v-model="customizeTheme.mainSidebar" id="mainMenu">
    <!-- ---------------------------------------------- -->
    <!---Top Area -->
    <!-- ---------------------------------------------- -->
    <template v-if="!customizeTheme.miniSidebar" v-slot:prepend>
      <v-card style="box-shadow: rgba(0, 0, 0, 0.05) 0px 25px 15px -20px" height="100"
        class="d-flex align-center justify-center">
        <img v-if="customizeTheme.darkTheme" width="200" src="@/assets/admin-logo-dark.png" alt="" />
        <img v-else="customizeTheme.darkTheme" width="200" src="@/assets/admin-logo-light.png" alt="" />
      </v-card>
    </template>

    <!-- ---------------------------------------------- -->
    <!---Nav List -->
    <!-- ---------------------------------------------- -->

    <main-menu :menu="navigation?.menu ?? []"></main-menu>

    <!-- ---------------------------------------------- -->
    <!---Bottom Area -->
    <!-- ---------------------------------------------- -->
    <!-- <template v-if="!customizeTheme.miniSidebar" v-slot:append>
      <v-card
        theme="dark"
        height="225"
        class="pa-3"
        variant="text"
        style="box-shadow: rgba(0, 0, 0, 0.05) 0px -25px 15px -20px"
      >
      </v-card>
    </template>
     -->
  </v-navigation-drawer>
</template>

<style scoped lang="scss"></style>
